import { useState } from 'react';
import { CalendarDays, ChevronDown, Check } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from '../ui/popover';

// Themed replacement for the native <select> month picker on the leaderboard.
export const LeaderboardMonthPicker = ({ months, value, currentKey, label, onChange, disabled }) => {
  const [open, setOpen] = useState(false);
  const pick = (key) => { setOpen(false); if (key !== value) onChange(key); };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button" disabled={disabled}
          className="ml-auto inline-flex items-center gap-1.5 rounded-full border border-primary/40 bg-primary/10 px-3 py-1.5 text-[11px] font-heading uppercase tracking-widest text-primary hover:bg-primary/20 transition-colors disabled:opacity-60"
          data-testid="leaderboard-month-select"
        >
          <CalendarDays className="h-3.5 w-3.5" />
          {value === currentKey ? 'This Month' : label(value)}
          <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end" sideOffset={8}
        className="w-60 p-1.5 rounded-2xl bg-[#0b0b0b]/95 backdrop-blur-xl border border-primary/30 shadow-[0_12px_40px_rgba(0,0,0,0.6),0_0_24px_rgba(255,215,0,0.08)]"
        data-testid="leaderboard-month-menu"
      >
        <p className="px-3 pt-2 pb-1.5 text-[10px] uppercase tracking-[0.2em] text-white/40">Show leaderboard for</p>
        <div className="max-h-72 overflow-y-auto">
          {months.map((key) => {
            const active = key === value;
            return (
              <button
                type="button" key={key} onClick={() => pick(key)}
                className={`w-full flex items-center justify-between gap-2 rounded-xl px-3 py-2.5 text-left text-sm transition-colors ${active ? 'bg-primary text-black font-semibold' : 'text-white/85 hover:bg-white/[0.06]'}`}
                data-testid={`leaderboard-month-option-${key}`}
              >
                <span className="flex flex-col">
                  <span>{label(key)}</span>
                  {key === currentKey && (
                    <span className={`text-[10px] uppercase tracking-widest ${active ? 'text-black/60' : 'text-primary/80'}`}>This month</span>
                  )}
                </span>
                {active && <Check className="h-4 w-4 shrink-0" />}
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default LeaderboardMonthPicker;
